export const formatPrice = (price, decimals = false) => {
    const [integerPart, decimalPart] = price.toString().split('.');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (decimals && decimalPart) {
        return `${formattedInteger},${decimalPart}`;
    }
    return formattedInteger;
}